'use strict'
import '@splidejs/splide/css';
import '@splidejs/splide-extension-video/dist/css/splide-extension-video.min.css'
import {Splide} from '@splidejs/splide';
import {Video} from '@splidejs/splide-extension-video';


// Глобальная переменная для отслеживания состояния
let videosCreatedForCurrentSplide = false;

function createVideosFromContainer(containerId) {
    const container = document.getElementById(containerId);
    if (!container) {
        return;
    }

    const videoWrappers = container.querySelectorAll('.splide__video__wrapper');

    videoWrappers.forEach(videoWrapper => {
        // Находим ближайшего родителя <li>
        let slide = videoWrapper.closest('.splide__slide');

        if (!slide) {
            return;
        }

        const videoSrc = slide.dataset.splideHtmlVideo;

        if (!videoSrc) {
            return;
        }

        const videoContainer = videoWrapper.querySelector('div'); // Получаем div внутри wrapper
        if (!videoContainer) {
            return;
        }

        if (videoContainer.querySelector('video')) {
            return; // Видео уже есть
        }

        const videoElement = document.createElement('video');
        videoElement.src = videoSrc;
        videoElement.autoplay = false;
        // Что бы iphone не открывал видео на весь экран при возврате на страницу.
        videoElement.disablePictureInPicture = true;
        videoElement.playsInline = true;
        videoElement.style.position = "absolute";

        videoContainer.appendChild(videoElement);
    });

    videosCreatedForCurrentSplide = true
}

let videoSlides = document.querySelectorAll('.splide__slide[data-splide-video-json]')
videoSlides.forEach(function (slide) {
    let video = JSON.parse(slide.dataset.splideVideoJson)
    let dataType = 'data-splide-html-video'
    if (document.body.clientWidth < 900) {
        if (video.MOBILE) {
            slide.setAttribute(dataType, video.MOBILE)
        }
    } else {
        if (video.DESKTOP) {
            slide.setAttribute(dataType, video.DESKTOP)
        }
    }
})

let elements = document.querySelectorAll('.splide:not(#brands)')
let splides = {};
for (let i = 0; i < elements.length; i++) {
    // Проверяем, существует ли уже экземпляр Splide
    if (!elements[i].Splide) {
        let slides = elements[i].querySelectorAll('.splide__slide')
        /**
         * Запрещаем перемотку слайда если там всего один слайд.
         * Так как при перемотке видео автоматически становится на паузу. А мы хотим запретить ставить его на паузу.
         */
        if (slides.length === 1) {
            elements[i].style.pointerEvents = 'none';
        }

        // Сбрасываем флаг перед обработкой нового Splide
        videosCreatedForCurrentSplide = false;
        splides[i] = new Splide(elements[i], {
            autoplay: true,
            loop: true,
            interval: 10_000,
            arrows: true,
            pagination: false,
            keyboard: 'global',
            type: 'loop',
            rewind: true,
            pauseOnHover: false,
            lazyLoad: 'nearby',
            video: {
                autoplay: true,
                mute: true,
                loop: false,
                hideControls: true,
                playerOptions: {
                    htmlVideo: {
                        autoplay: true,
                        mute: true,
                        loop: false,
                        preload: "auto",
                        disablePictureInPicture: true,
                        playsInline: true,
                    },
                },
            },
        }).on('active', slider => {
            if (slider.isClone) {
                return;
            }

            // Ожидаем, пока флаг изменится
            const waitForVideos = () => {
                if (videosCreatedForCurrentSplide) {
                    let nextVideo = slider.slide.nextElementSibling.querySelector('video');
                    if (nextVideo) {
                        nextVideo.load()
                    }

                    // Что бы iphone не открывал видео на весь экран при возврате на страницу.
                    // В Splide не устанавливается корректно
                    slider.slide.querySelector('video').setAttribute('playsInline', true);
                    slider.slide.querySelector('video').setAttribute('disablePictureInPicture', true);
                } else {
                    // Если флаг еще не установлен, ждем и пробуем снова
                    setTimeout(waitForVideos, 1000); // Проверяем каждые 1000мс
                }
            };
            waitForVideos();

        })
            .mount({
                Video
            })
            .on('video:play', slider => {
                slider.Splide.Components.Autoplay.pause()
            })
            .on('video:ended', player => {
                player.Splide.Components.Autoplay.play()
                player.play()
                if (!splides[i].root.hasAttribute('data-dragging')) {
                    player.Splide.go('>')
                }
            })
            .on('move', (newIndex, prevIndex) => {
                // Выводим информацию какой сейчас слайд
                splides[i].root.querySelector('.splide__counter').textContent = newIndex + 1 + '/' + splides[i].length

                document.querySelectorAll('.splide__video .splide__video__wrapper').forEach(element => {
                    element.style.display = 'block'
                })

                let newVideo = splides[i].Components.Slides.getIn(newIndex)[0].slide.querySelector('video')
                if (newVideo && newVideo.paused) {
                    newVideo.play()
                }

                let prevVideo = splides[i].Components.Slides.getIn(prevIndex)[0].slide.querySelector('video')
                if (prevVideo && prevVideo.paused) {
                    prevVideo.play()
                }

            })
            .on('moved', (newIndex, prevIndex) => {
                let allVideo = splides[i].Components.Slides.getIn(newIndex)[0].slide.querySelectorAll('video');
                if (allVideo && allVideo.length === 2) {
                    const firstVideo = allVideo[0];
                    const secondVideo = allVideo[1];

                    // Получаем состояние воспроизведения первого видео
                    const isPlaying = !firstVideo.paused; // paused === true значит видео остановлено, !paused === true значит играет

                    // Устанавливаем состояние воспроизведения для второго видео
                    if (isPlaying) {
                        secondVideo.play();
                    } else {
                        secondVideo.pause();
                    }
                    secondVideo.currentTime = firstVideo.currentTime;
                    secondVideo.addEventListener("canplay", () => {
                        firstVideo.remove();
                    })
                }

                let prevVideo = splides[i].Components.Slides.getIn(prevIndex)[0].slide.querySelector('video')
                if (prevVideo) {
                    prevVideo.pause()
                    prevVideo.currentTime = 0;
                }
            })
            .on('dragging', () => {
                splides[i].root.dataset.dragging = ""

                let currentIndex = splides[i].Components.Controller.getIndex()
                let currentVideo = splides[i].Components.Slides.getIn(currentIndex)[0].slide.querySelector('video')
                if (currentVideo && currentVideo.paused) {
                    currentVideo.play()
                }

                let newIndex = splides[i].Components.Controller.getNext()
                let newVideo = splides[i].Components.Slides.getIn(newIndex)[0].slide.querySelector('video')
                if (newVideo && newVideo.paused) {
                    newVideo.play()
                }

                let prevIndex = splides[i].Components.Controller.getPrev()
                let prevVideo = splides[i].Components.Slides.getIn(prevIndex)[0].slide.querySelector('video')
                if (prevVideo && prevVideo.paused) {
                    prevVideo.play()
                }
            })
            .on('dragged', () => {
                splides[i].root.removeAttribute('data-dragging');
            })
        // Для Ambient эффекта
        if (elements[i].classList.contains('splide_ambient')) {
            splides[i].sync(splides[i - 1]);
        }
        // Выводим информацию какой сейчас слайд
        splides[i].root.querySelector('.splide__counter').textContent = 1 + '/' + splides[i].length
        createVideosFromContainer(splides[i].root.id)
    }
}

window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
        let videoSlides = document.querySelectorAll('.is-active.splide__slide[data-splide-video-json]')
        videoSlides.forEach(function (slide) {
            let video = slide.querySelector('video')
            if (video) {
                video.play()
            }
        })
    }
})